import { mapParamsBySchema } from '../../../../util';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import { M_FILE_CUSTOM_03_Schema } from './M_FILE_CUSTOM_03_Schema';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { handleQuerySuccess } from '../../../../Hooks/apis/useQuriesSuccess';
import useSearchMutaion from '../../../../Hooks/apis/useSearchMutaion';

/** 교육 자료 조회 getTbmNewR8 */
export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(M_FILE_CUSTOM_03_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['File', 'getTbmNewR8', params],
    queryFn: () => apiRequest('post', Global.urls.ToolBoxMeeting.getTbmNewR8, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

/** 안전작업허가서 마스터 목록 조회 getTbmNewR6 */
export const useSearch2 = (successOptions) => {
  return useSearchMutaion(async (context) => {
    const payload = mapParamsBySchema(M_FILE_CUSTOM_03_Schema.mapper.search2, context);
    return apiRequest('post', Global.urls.ToolBoxMeeting.getTbmNewR6, payload);
  }, successOptions);
};

/** 안전작업허가서 데일리 목록 조회 getTbmNewR7 */
export const useSearch3 = (successOptions) => {
  return useSearchMutaion(async (context) => {
    const payload = mapParamsBySchema(
      M_FILE_CUSTOM_03_Schema.mapper.search3,
      context
    );
    return apiRequest('post', Global.urls.ToolBoxMeeting.getTbmNewR7, payload);
  }, successOptions);
};
